import type {ReactElement} from 'react';
import React from 'react';
import {BaseFillColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-fill-color-panel';
import type {ColorFillPropertyType} from '@Components/color-fill';
import {getFillTypeFromColorFillType, getRGBAArrayFromColorStorage} from '@Utils/color.util';
import type {ColorStorage} from '@Components/color-picker-v2';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetSelectedSlideId} from '@Hooks/poster-editor/useGetSelectedSlideId';
import {usegetKeyOfFillOfBackgroundOfTextSlideItem} from '@Hooks/poster-editor/usegetKeyOfFillOfBackgroundOfTextSlideItem';

export function TextSlideBackgroundColorPanel(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeSlideUID = useGetSelectedSlideId();
  const activeSlide = activeSlideUID && activeItem?.isSlideshow() ? activeItem.getSelectedSlide() : null;
  const fillType = usegetKeyOfFillOfBackgroundOfTextSlideItem('fillType');
  const fillColor = usegetKeyOfFillOfBackgroundOfTextSlideItem('fillColor');

  if (!activeItem?.isSlideshow()) {
    throw new Error(`Expected slideshow item but got ${activeItem?.gitype}`);
  }

  if (!activeSlide?.isTextSlide()) {
    throw new Error(`Expected text slideshow item but got ${activeSlide?.gitype}`);
  }

  if (!activeSlideUID) {
    throw new Error('unable to get the selected text slide');
  }

  if (fillType === undefined || !fillColor) {
    throw new Error('unable to get the fill properties of background of selected text slide');
  }

  const onChangeType = (newType: ColorFillPropertyType): void => {
    void activeItem.updateSlideFromObject(activeSlide.uid, {
      background: {
        fill: {
          fillType: getFillTypeFromColorFillType(newType),
          fillColor: activeSlide.background.fill.getColorForNewType(getFillTypeFromColorFillType(newType)),
        },
      },
    });
  };

  const onChangeColor = (updatedColor: ColorStorage[]): void => {
    void activeItem.updateSlideFromObject(
      activeSlide.uid,
      {
        background: {
          fill: {
            fillColor: getRGBAArrayFromColorStorage(updatedColor),
          },
        },
      },
      {
        undoable: false,
      }
    );
  };
  const onChangeColorEnded = (updatedColor: ColorStorage[]): void => {
    void activeItem.updateSlideFromObject(activeSlide.uid, {
      background: {
        fill: {
          fillColor: getRGBAArrayFromColorStorage(updatedColor),
        },
      },
    });
  };

  return (
    <BaseFillColorPanel
      colorObject={{
        fillType,
        fillColor,
      }}
      onChangeColor={onChangeColor}
      onChangeColorEnded={onChangeColorEnded}
      onChangeType={onChangeType}
    />
  );
}
